export default __webpack_public_path__ + "static/media/advance_filter.c2d43b3f.png";